import Controller from '@philips-emr/tws-core/lib/client';

import { FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

import './health-declaration.scss';

@Controller({ fragment: FragmentNames.HEALTH_DECLARATION_INVALID })
export default class HealthDeclarationInvalidController extends BaseController {

}
